import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref } from 'vue';
import { useBasicStore } from '../../../stores/basic';
import { storeToRefs } from 'pinia';
import TUIRoomAegis from '../../utils/aegis';


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkInfo',
  setup(__props) {

const networkDes = ['状态未知', '状态极佳', '状态较好', '状态一般', '状态差', '状态极差', '断开连接'];

const basicStore = useBasicStore();
const { localQuality, statistics, localVideoBitrate, localFrameRate } = storeToRefs(basicStore);

const networkBoard = ref();
const showNetworkInfo: Ref<boolean> = ref(false);

function showGreen(index: number) {
  if (localQuality.value === 0) {
    return false;
  }
  return 5 - localQuality.value > index;
}

function handleClickNetworkIcon() {
  if (!showNetworkInfo.value) {
    showNetworkInfo.value = true;
    document.addEventListener('click', handleDocumentClick, false);
  } else {
    document.removeEventListener('click', handleDocumentClick, false);
    showNetworkInfo.value = false;
  }
  TUIRoomAegis.reportEvent({ name: 'networkInfo', ext1: 'networkInfo' });
}

function handleDocumentClick(event: MouseEvent) {
  if (showNetworkInfo.value && networkBoard.value && !networkBoard.value.contains(event.target as Node)) {
    document.removeEventListener('click', handleDocumentClick);
    showNetworkInfo.value = false;
  }
}


return { __sfc: true,networkDes, basicStore, localQuality, statistics, localVideoBitrate, localFrameRate, networkBoard, showNetworkInfo, showGreen, handleClickNetworkIcon, handleDocumentClick }
}

})